import React, { Component } from 'react';

import {__} from "../Translator";

import './ModelColor.css'
import Dropdown from "../components/Dropdown";
import Footer from "../components/Footer";
import StepIndicator from "../components/StepIndicator";
import Header from "../components/Header";

import { thronImageUrl } from "../Helpers";
import AppStore from "../flux/AppStore";
import AppActions from "../flux/AppActions";
import ProductPriceDetailed from "../components/ProductPriceDetailed";
import currencySymbol from '../utils/currencySymbol';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';


class ModelColor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      country: CountriesStore.find(CountryStore.getState()),
      customProduct: AppStore.getCustomProduct(),
      colorLength:  AppStore.getCustomProduct().product.standard_colors.length,
    };

    props.navigation.onBack(() => {
      this.props.navigation.navigate(this.state.customProduct.product.perforable === null ? 'modelPerforate' : 'modelSelection');
    });

    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
  }

  componentDidMount() {
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);

    this.onCustomizeChange(this.state.customProduct.custom_colored);
  }

  componentWillUnmount() {
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
  }

  onCustomProductUpdate() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  onCustomizeChange(willCustomize) {
    AppActions.updateCustomProduct({ custom_colored: willCustomize });
  }

  onProductColorChange(color){
    AppActions.updateCustomProduct({ custom_colored: false, preset: color ? color.name : "Default", productPresetName: color ? color.name : "Default", productCode: this.state.customProduct.product.code  });
    this.props.navigation.navigate('modelFit');
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}
          heroTitle={__('Choose your color')}
          heroText={<p>{__('Choose a standard color option or go through our 3D product and customize colors, accessories and add-on following your own creativity.')}</p>}
          breadcrumb={['Homepage', 'Product', this.state.customProduct.product.name, "Design"]}
        />

        <Footer
          navigation={this.props.navigation}
          productSpecification={this.state.customProduct.product}
        />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row u-h-100">
            <div className="col-lg-6 col-lg-offset-3 col-xs-8 col-xs-offset-2">
              <div className="main__hero">
                <h1 className="hero__title">{__('Select your design')}</h1>
                <div className="hero__text">
                  <p>{__('Select Custom design to change leather colors, select the accessories you want and apply your own text and images')}</p>
                </div>
              </div>
              <Dropdown

                className="dropdown--large"
                  title={__('Please select your design')}
                options={[
                  { value: 1,
                    disabled: this.state.customProduct.product.custom_color === 0 ,
                  online_purchase: this.state.country.online_purchase,
                    text: <span>{__('Custom design')}
                    {this.state.customProduct.product.custom_color !== 0 ?
                      <small>{shouldShowPrice(CountryStore.getState()) ?
                        " + "+parseFloat(this.state.customProduct.product.customization_price).toLocaleString(undefined, {minimumFractionDigits: 2}) + " " + currencySymbol(undefined, {minimumFractionDigits: 2})
                        : ""}</small>
                      :
                      <span className="alert-message">{__(' - Not available for this model')}</span> }
                  </span>},
                  { value: false,
                    online_purchase: 0,
                    disabled: this.state.customProduct.product.custom_color === 1 || this.state.country.online_purchase === 1,
                    text: <span>{__('Existing design')}
                    {this.state.customProduct.product.custom_color !== 1 ?
                      <small>{shouldShowPrice(CountryStore.getState()) ? " + "+parseFloat('0').toLocaleString(undefined, {minimumFractionDigits: 2})+" "+currencySymbol(undefined, {minimumFractionDigits: 2})
                        : ""}</small>
                      : <span className="alert-message">{__(' - Not available for this model')}</span>
                    }</span> },

                ]}
                selected={this.state.customProduct.custom_colored}
                onChange={v => this.onCustomizeChange(v)}
              />

              {this.state.customProduct.custom_colored === null ? (
                null
              ) : (
                this.state.customProduct.custom_colored ? (
                  <div className="u-ta-center u-mt-60">
                    <button className="btn btn-primary btn-xlg btn-next" onClick={() => {
                      this.props.navigation.navigate('modelFit');
                    }}>
                      {__('Next')}
                    </button>
                  </div>
                ) : (
                  <div>
                  <h3 className="productColorList__title">{__('Choose color')}<small>*</small></h3>

                  <div className="productColorListContainer">
                    {this.state.customProduct.product.standard_colors.map((color, index) => (
                      <div
                        key={color.code}
                        className={`productColorContainer ${(index === AppStore.getCustomProduct().product.standard_colors.length - 1 && AppStore.getCustomProduct().product.standard_colors.length > 3)? 'extra-space' : ''}`}
                        onClick={() => {
                          this.onProductColorChange(color);
                        }}
                      >
                        <img className="productColor__image" src={thronImageUrl(color.preview_image_url, ProductPriceDetailed.ProductImageWidth, ProductPriceDetailed.ProductImageHeight)} alt={color.name} />
                        <div className="productColor__meta">
                          <div className="colorModel__name">
                            <div className="text-cell"> 
                              <strong className="productColor__name">{color.name}</strong>
                              <div className="productColor__description">{color.description}</div>
                            </div>
                          </div>
                          <div className="productModel__select">
                            <button className="btn btn-primary" onClick={() => this.onProductColorChange(color)}>
                              {__('SELECT')}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModelColor;



// WEBPACK FOOTER //
// ./src/screens/ModelColor.js